import { dataOn } from "../../main/data/data";
export function handleClassrooms() {
    const classroomList = document.querySelector(".cp-classrooms__list");
    console.log(classroomList);
    dataOn("bible-classes", (data) => {
        let classroomListHTML = "";
        console.log(data);
        // TODO: edit rooms?
        data.numbered.forEach((room) => {
            console.log(room);
            classroomListHTML += `
                <li class="cp-classrooms__class" style="display: grid; grid-template-columns: 1fr 1fr 1fr;">
                    <p>${room.id}</p>
                    <p>${room.name}</p>
                    <p>${room.description}</p>
                </li>
            `;
        });
        classroomList.innerHTML = classroomListHTML;
    });
}
